class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverDelay = 180;
    this.closeTimer = null;
    this.bindHoverOpen();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  // BabyBoo-style: open mega menu on hover (desktop only). Closes when
  // pointer leaves the parent <header-menu> element with a small delay so
  // moving between summary and panel doesn't dismiss.
  bindHoverOpen() {
    const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;

    this.addEventListener('mouseenter', () => {
      if (!isDesktop()) return;
      clearTimeout(this.closeTimer);
      if (!this.mainDetailsToggle.hasAttribute('open')) {
        this.mainDetailsToggle.setAttribute('open', '');
        const summary = this.mainDetailsToggle.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'true');
      }
    });

    this.addEventListener('mouseleave', () => {
      if (!isDesktop()) return;
      this.closeTimer = setTimeout(() => this.close(), this.hoverDelay);
    });

    // Cancel close if pointer re-enters while the timer is running
    this.addEventListener('focusin', () => clearTimeout(this.closeTimer));
  }
}

customElements.define('header-menu', HeaderMenu);

